/*
 * $Id:: index.js 2021/01/14 03:43 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useRef } from 'react';

import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Popover from '@material-ui/core/Popover';
import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as CaretDouble } from '../../assets/images/caretDouble.svg';
import { t } from '../../providers';
import CalendarWrapper from './CalendarWrapper';

const useStyles = makeStyles(() => ({
    textInput: {
        height: '2rem',
        width: 'auto',
        borderRadius: '4px',
        marginRight: '10px',
        cursor: 'pointer',
        '& input': {
            cursor: 'pointer',
            '&::placeholder': {
                opacity: '1',
                color: '#6B6C7E',
                fontSize: '14px',
            },
        },
        '@media (max-width:600px)': {
            width: '9.5rem',
        },
        '& .MuiSelect-icon': {
            top: 'calc(50% - 6px)',
        },
    },
    doubleCarretIcon: {
        marginRight: '0.7rem',
    },
}));

const UARangePicker = (props) => {
    const classes = useStyles();

    const { id, onClose, customInputEndAdornment, ...restProps } = props;

    const [range] = useState('');

    const inputEl = useRef(null);

    const [anchorEl, setAnchorEl] = useState(null);

    const toggleCalendar = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closeCalendar = (event) => {
        setAnchorEl(null);
        onClose(event);
    };

    const isOpen = Boolean(anchorEl);

    return (
        <div>
            <Input
                ref={inputEl}
                id={`${id}_datepicker`}
                className={classes.textInput}
                placeholder={t('dates')}
                type="input"
                name="search"
                readOnly
                fullWidth
                required
                onClick={toggleCalendar}
                value={range}
                endAdornment={
                    customInputEndAdornment || (
                        <InputAdornment position="end" className={classes.doubleCarretIcon}>
                            <CaretDouble />
                        </InputAdornment>
                    )
                }
            />
            <Popover
                id={id}
                open={isOpen}
                anchorEl={anchorEl}
                onClose={closeCalendar}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <CalendarWrapper {...restProps} />
            </Popover>
        </div>
    );
};

export default UARangePicker;
